<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 부가정보 : 사업개요 정보-->
    <write-grid-container title="사업개요 정보" v-model="form.subInfo" :options="gridContainerOptions" class="mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <custom-option-selector v-if="dataType === 'selector'" class="w-full" v-model="form.subInfo[value]" :options="result_options1" @input="onInputSelector" />
          <custom-option-selector v-else-if="dataType === 'selector2'" class="w-full" v-model="form.subInfo[value]" :options="result_options2" />
          <number-input v-else-if="dataType === 'number'" class="w-full" ro ws="5" v-model="form.subInfo[value]" :max="9999" />
          <DateSelector v-else-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <FileDownloadPost :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" title="파일첨부" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import FileDownloadPost from "@/components/FileDownloadPost.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";

import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    FileDownloadPost,
    NumberInput,
    DateSelector,
    CustomOptionSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      result_options1: ["100. 사업개요", "210. 유해위험물질목록", "220. 사양서", "230. 공정개요 및 P&ID", "240. 내화, 소방 도면 등", "250. 방폭 현황", "260. 안전설계지침", "270. 환경인허가서류"],
      result_options2: [],
      data_result_options2: {
        "100. 사업개요": ["사업개요", "해당없음"],
        "210. 유해위험물질목록": ["211. 유해위험물목록", "212. 물질안전보건자료(MSDS)", "해당없음"],
        "220. 사양서": ["221. 동력기계목록", "222. 장치 및 설비 명세", "223. 배관 및 가스켓 사양", "224. 안전밸브 사양서", "225. 축열볼 사양서", "226. 이상발생 시 인터록 조건", "해당없음"],
        "230. 공정개요 및 P&ID": ["231. 공정개요", "232. PFD", "233. P&ID", "234. UFD", "해당없음"],
        "240. 내화, 소방 도면 등": [
          "241. 전체배치도",
          "242. 설비배치도",
          "243. 건축도면",
          "244. 내화구조",
          "245. 소화설비 설치현황 및 배치도",
          "246. 화재탐지 및 경보설비 배치도",
          "247. 가스감지기",
          "248. 안전보호설비의 설치현황",
          "해당없음",
        ],
        "250. 방폭 현황": ["251. 방폭전기기계기구 선정기준", "252. 폭발위험장소 구분도", "253. 전기단선도", "254. 접지계획", "해당없음"],
        "260. 안전설계지침": ["안전설계제작 및 설치관련지침", "해당없음"],
        "270. 환경인허가서류": ["설치/운영허가 검토결과서", "해당없음"],
      },
      gridContainerOptions: {
        dataTypes: ["string", "selector", "selector2", "number", "date"],
        labels: ["공장명", "구분1", "구분2", "Rev", "제개정일"],
        values: ["공장명", "구분1", "구분2", "Rev", "제개정일"],
      },
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    onInputSelector() {
      if (this.form.subInfo && this.form.subInfo["구분1"]) {
        this.form.subInfo["구분2"] = "";
        this.result_options2 = this.data_result_options2[this.form.subInfo["구분1"]];
      } else this.result_options2 = [];
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
